import { render, staticRenderFns } from "./SummitWistiaVideoGroup.vue?vue&type=template&id=71345038&"
import script from "./SummitWistiaVideoGroup.vue?vue&type=script&lang=js&"
export * from "./SummitWistiaVideoGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports